export const BillingStatusesEnum = {
  active: "active",
  suspended: "suspended",
};
